import { useEffect } from 'react';
import HowToSyncBody from '../../components/HowToSync/HowToSyncBody'
import HowToSyncHeader from '../../components/HowToSync/HowToSyncHeader'
import Loader from '../../components/Loader/Loader';
import { useHowToSyncContext } from '../../providers/HowToSyncProvider';
import './HowToSync.scss'

export default function HowToSync() {
    const howToSyncContext = useHowToSyncContext();
    useEffect(()=>{
        howToSyncContext.getVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        howToSyncContext.loading ? <Loader />:
        <div>
            <HowToSyncHeader />
            <HowToSyncBody />
        </div>  
    )
}
